import { RightType } from "../../../Global/Base/Rights/RightTypes";
import { EnumUtils } from "../../../Global/Base/Utils/EnumUtils";

export enum ControlRightTypesGroup {
    IED = 1 << 0,
    initialized = 1 << 1,
    selectionChanged = 1 << 2,
    inEdit = 1 << 3,
    attributeChange = 1 << 4,
    beforeSave = 1 << 5,
}

export class RightGroups {
    /**
     * Skupiny typů práv
     */
    protected static _controlRightTypesGroups: Map<ControlRightTypesGroup, RightType[]> = new Map([
        [ControlRightTypesGroup.IED, [RightType.insert, RightType.edit, RightType.delete]],
        [ControlRightTypesGroup.initialized, [RightType.visible, RightType.enabled, RightType.editing, RightType.interactive]],
        [ControlRightTypesGroup.selectionChanged, [RightType.edit, RightType.delete, RightType.visible, RightType.enabled, RightType.required, RightType.postponedRequired, RightType.editing, RightType.interactive, RightType.multiEditing]],
        [ControlRightTypesGroup.beforeSave, [RightType.required, RightType.editing, RightType.interactive]],
        [ControlRightTypesGroup.inEdit, [RightType.visible, RightType.enabled, RightType.required, RightType.postponedRequired, RightType.recommended, RightType.editing, RightType.multiEditing]],
        [ControlRightTypesGroup.attributeChange, [RightType.edit, RightType.delete, RightType.visible, RightType.enabled, RightType.required, RightType.postponedRequired, RightType.recommended]],
    ]);

    protected static _controlPriorityRightTypesGroups: Map<ControlRightTypesGroup, RightType[]> = new Map([
        [ControlRightTypesGroup.IED, []],
        [ControlRightTypesGroup.initialized, [RightType.useDigitalSign, RightType.useEncryption, RightType.useDecryption]],
        [ControlRightTypesGroup.selectionChanged, [RightType.useDigitalSign, RightType.useEncryption, RightType.useDecryption]],
        [ControlRightTypesGroup.beforeSave, []],
        [ControlRightTypesGroup.inEdit, []],
        [ControlRightTypesGroup.attributeChange, []],
    ]);

    public static getControlRightGroupTypes(controlRightGroup: ControlRightTypesGroup): RightType[] {
        return RightGroups._getControlRightTypesFromGroup(controlRightGroup, RightGroups._controlRightTypesGroups);
    }
    public static getControlPriorityRightGroupTypes(controlRightGroup: ControlRightTypesGroup): RightType[] {
        return RightGroups._getControlRightTypesFromGroup(controlRightGroup, RightGroups._controlPriorityRightTypesGroups);
    }

    private static _getControlRightTypesFromGroup(controlRightGroup: ControlRightTypesGroup, collection: Map<ControlRightTypesGroup, RightType[]>): RightType[] {
        const resultRightTypesSet: Set<RightType> = new Set();
        const decomposedFlags = EnumUtils.decomposeFlagEnumValue(ControlRightTypesGroup, controlRightGroup);

        for (const flag of decomposedFlags) {
            collection.get(flag)?.forEach(rightType => resultRightTypesSet.add(rightType));
        }

        return [...resultRightTypesSet];
    }
}
